<script setup>
import { ref, computed, watch } from 'vue';

const props = defineProps({
  locations: { type: Array, required: true },
  initialLocationId: { type: Number, default: null },
  initialBatchId: { type: Number, default: null },
});

const locationId = ref(props.initialLocationId ?? props.locations[0]?.id ?? '');
const batchId = ref(props.initialBatchId ?? '');

const batches = computed(() =>
  props.locations.find((location) => location.id === locationId.value)?.batches ?? []
);

function syncBatch() {
  if (batches.value.some((batch) => batch.id === batchId.value)) {
    return;
  }

  batchId.value = batches.value.length === 1 ? batches.value[0].id : '';
}

syncBatch();
watch(locationId, syncBatch);
</script>
<template>
    <div>
        <div class="form-group mb-3">
            <label for="barcode_stock_location_id" class="form-label">{{ $t('Stock location') }}</label>
            <select
                id="barcode_stock_location_id"
                name="barcode_stock_location_id"
                class="form-control"
                v-model="locationId"
                required
            >
                <option v-for="location in locations" :key="location.id" :value="location.id">
                    {{ location.name }} ({{ $t('{count} available', { count: location.available_count.toLocaleString() }) }})
                </option>
            </select>
        </div>

        <div class="form-group mb-3">
            <label for="barcode_batch_id" class="form-label">{{ $t('Batch') }}</label>
            <select
                id="barcode_batch_id"
                name="barcode_batch_id"
                class="form-control"
                v-model="batchId"
                :disabled="batches.length === 0"
                required
            >
                <option value="" disabled>{{ $t('Select a batch') }}</option>
                <option v-for="batch in batches" :key="batch.id" :value="batch.id">
                    {{ batch.filename }} ({{ $t('{count} available', { count: batch.available_count.toLocaleString() }) }})
                </option>
            </select>
            <small v-if="batches.length === 0" class="form-text text-muted">
                {{ $t('No available barcodes in this location') }}
            </small>
        </div>
    </div>
</template>
